import React from 'react';
import { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [date, setDate] = useState(null);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [website, setWebsite] = useState('');
  const [twitter, setTwitter] = useState('');
  const [telegram, setTelegram] = useState('');
  const [discord, setDiscord] = useState('');
  const [blog, setBlog] = useState('');
  const [unlockedTge, setUnlockedTge] = useState(0);
  const [vestingPeriod, setVestingPeriod] = useState(0);
  const [price, setPrice] = useState(0);
  const [allocation, setAllocation] = useState(0);
  const [poolFee, setPoolFee] = useState(0);
  const [poolUrl, setPoolUrl] = useState('');
  useEffect(() => {
    async function getDate() {
      const res = await fetch('/api/date');
      const newDate = await res.text();
      setDate(newDate);
    }
    getDate();
  }, []);

  const saveProject = async () => {
    const project = {
      name,
      description,
      website,
      twitter,
      telegram,
      discord,
      blog,
      unlockedTge,
      vestingPeriod,
      price,
      allocation,
      poolFee,
      poolUrl,
    };
    const res = await fetch('https://backend-black.vercel.app/api/project', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(project),
    })
      .then(response => alert(response.json().message))
      .catch(error => {
        alert('Error:', error);
      });
  };

  return (
    <main>
      <h1>Gentlemen Capital portal</h1>
      <p>
        <p>Project Name</p>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          type="text"></input>
        <p>Project Description</p>
        <input
          value={description}
          onChange={e => setDescription(e.target.value)}
          type="text"></input>
        <p>Project Website</p>
        <input
          value={website}
          onChange={e => setWebsite(e.target.value)}
          type="text"></input>
        <p>Project Twitter</p>
        <input
          value={twitter}
          onChange={e => setTwitter(e.target.value)}
          type="text"></input>
        <p>Project Telegram</p>
        <input
          value={telegram}
          onChange={e => setTelegram(e.target.value)}
          type="text"></input>
        <p>Project Discord</p>
        <input
          value={discord}
          onChange={e => setDiscord(e.target.value)}
          type="text"></input>
        <p>Project Blog</p>
        <input
          value={blog}
          onChange={e => setBlog(e.target.value)}
          type="text"></input>
        <p>Project Unlocked at Tge</p>
        <input
          value={unlockedTge}
          onChange={e => setUnlockedTge(e.target.value)}
          type="number"></input>
        <p>Project Vesting Period</p>
        <input
          value={vestingPeriod}
          onChange={e => setVestingPeriod(e.target.value)}
          type="number"></input>
        <p>Project Price</p>
        <input
          value={price}
          onChange={e => setPrice(e.target.value)}
          type="number"></input>
        <p>Project Allocation</p>
        <input
          value={allocation}
          onChange={e => setAllocation(e.target.value)}
          type="number"></input>
        <p>Project Pool Fee</p>
        <input
          value={poolFee}
          onChange={e => setPoolFee(e.target.value)}
          type="number"></input>
        <p>Project Pool Url</p>
        <input
          value={poolUrl}
          onChange={e => setPoolUrl(e.target.value)}
          type="text"></input>
        <br />
        <input onClick={saveProject} type="button" />
        submit
      </p>
      <br />
      <h2>The date according to Server is:</h2>
      <p>{date ? date : 'Loading date...'}</p>
    </main>
  );
}

export default App;
